export enum TipoPrecio {
  Publico = 0, //Final
  Lista = 1,   //Base
}
